import { Label } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './dropdown.scss';

type Props = ComponentPropsWithoutRef<typeof Label> & {
    inset?: boolean;
};
export const DropdownLabel = ({ className, inset, ...props }: Props) => {
    return (
        <Label
            data-testid="dropdown-label"
            data-inset={inset}
            className={cn('dropdown__label', inset && 'dropdown__label--inset', className)}
            {...props}
        />
    );
};
